import { __assign } from "tslib";
import React, { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { MatureDeviationContext } from '../../Context/MatureDeviationContext';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType, getShouldDisplayPaywall, } from '../_helpers';
import HiddenOverlay from '../HiddenOverlay';
import FolderPaywallFullView from './_partials/FolderPaywall';
import ImageFullView from './Image';
import FilmFullView from './Film';
import JournalFullView from './Journal';
import LiteratureFullView from './Literature';
import PdfFullView from './Pdf';
import PollFullView from './Poll';
import StatusFullView from './Status';
import CommissionFullView from './Commission';
import TierFullView from './Tier';
import UnknownFullView from './Unknown';
import SubPaywall from './_partials/SubPaywall';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import { overrideSubscribeMatureFilter } from '../../Tier/redux/consumer/actions';
var DeviationFullView = function (props) {
    var dispatch = useDispatch();
    var deviation = props.deviation;
    var deviationType = getDeviationType(deviation);
    var _a = useSubscriptionTier(props.deviation), isSubscribedButBlocked = _a.isSubscribedButBlocked, needsSubscription = _a.needsSubscription;
    var _b = useContext(MatureDeviationContext), showBlocked = _b.showBlocked, overrideMatureFilter = _b.overrideMatureFilter;
    var overrideMatureFilterWrapper = useCallback(function () {
        if (deviationType === DeviationTypes.TIER) {
            dispatch(overrideSubscribeMatureFilter(deviation));
        }
        overrideMatureFilter();
    }, [overrideMatureFilter, dispatch, deviation, deviationType]);
    if (showBlocked) {
        return (React.createElement(HiddenOverlay, __assign({ overrideMatureFilter: overrideMatureFilterWrapper }, props)));
    }
    var isPremiumLocked = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData).isPremiumLocked;
    if (isPremiumLocked && deviationType !== DeviationTypes.LITERATURE) {
        return React.createElement(FolderPaywallFullView, __assign({}, props));
    }
    var isBlocked = needsSubscription || isSubscribedButBlocked;
    if (isBlocked && getShouldDisplayPaywall(deviationType)) {
        return React.createElement(SubPaywall, __assign({}, props, { showImage: true }));
    }
    switch (deviationType) {
        case DeviationTypes.IMAGE:
            return React.createElement(ImageFullView, __assign({}, props));
        case DeviationTypes.FILM:
            return React.createElement(FilmFullView, __assign({}, props));
        case DeviationTypes.PDF:
            return React.createElement(PdfFullView, __assign({}, props));
        case DeviationTypes.LITERATURE:
            return React.createElement(LiteratureFullView, __assign({}, props));
        case DeviationTypes.JOURNAL:
            return React.createElement(JournalFullView, __assign({}, props));
        case DeviationTypes.STATUS:
            return React.createElement(StatusFullView, __assign({}, props));
        case DeviationTypes.POLL:
            return React.createElement(PollFullView, __assign({}, props));
        case DeviationTypes.COMMISSION:
            return React.createElement(CommissionFullView, __assign({}, props));
        case DeviationTypes.TIER:
            return React.createElement(TierFullView, __assign({}, props));
        default:
            return React.createElement(UnknownFullView, __assign({}, props, { type: deviationType }));
    }
};
export default DeviationFullView;
//# sourceMappingURL=Full.js.map